export default __webpack_public_path__ + "static/media/family2.9a18008c.jpg";